module.exports = __webpack_public_path__ + "img/ocean-plus-main-logo.d5220070.svg";